module.exports = {
    props: ['user', 'team'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: $.extend(true, new SparkForm({
                ai_enabled: '',
                ai_categorization_enabled: '',
                gpt_claim_prompt_id: '',
                ai_prompt_group_id: '',
                category_gpt_claim_prompt_id: '',
                ai_categorization_prompt_id: '',
                send_email_on_complete: '',
                send_email_on_ai_completion: '',
                ai_completion_recipients: '',
            }), Spark.forms.updateAiSettings)
        };
    },


    /**
     * Bootstrap the component.
     */
    mounted() {
        console.log(this.team.send_email_on_ai_completion);
        this.form.ai_enabled = this.team.ai_enabled;
        this.form.ai_categorization_enabled = this.team.ai_categorization_enabled;
        this.form.gpt_claim_prompt_id = this.team.gpt_claim_prompt_id;
        this.form.ai_prompt_group_id = this.team.ai_prompt_group_id;
        this.form.category_gpt_claim_prompt_id = this.team.category_gpt_claim_prompt_id;
        this.form.ai_categorization_prompt_id = this.team.ai_categorization_prompt_id;
        this.form.send_email_on_complete = this.team.send_email_on_ai_completion != '0';
        this.form.send_email_on_ai_completion = this.team.send_email_on_ai_completion;
        this.form.ai_completion_recipients = this.team.ai_completion_recipients ? JSON.parse(this.team.ai_completion_recipients).join(', ') : '';
    },


    methods: {
        /**
         * Update the user's contact information.
         */
        update() {
            Spark.put(`/settings/${Spark.teamsPrefix}/${this.team.id}/ai-settings`, this.form)
                .then(() => {
                    Bus.$emit('updateTeam');
                });
        }
    }
};
